<template>
	<v-menu
		open-on-hover
		:close-on-content-click="false"
		v-if="isLoggedIn"
	>
		<template v-slot:activator="{on, attrs}">
			<v-btn
				icon
				title="Atsijungti"
				class="ml-3"
				v-on="on"
				v-bind="attrs"
			>
				<v-icon :color="dark ? 'white' : undefined">mdi-account</v-icon>
			</v-btn>
		</template>
		<div class="pa-3 logout-content">
			<strong>{{$store.state.userData.userName}}</strong>
			<div class="mt-2">
				<v-btn
					plain
					v-on:click="logout"
					elevation=0
					small
				>
					Atsijungti
				</v-btn>
			</div>
		</div>
	</v-menu>
</template>

<script>
	import CommonHelper from "./helpers/CommonHelper";

	export default {
		props: {
			dark: Boolean
		},
		data: function(){
			var data = {
				isLoggedIn: CommonHelper.isUserSigned()
			};
			return data;
		},
		methods: {
			logout: function(){
				var logoutUrl = "https://" + window.location.host + "/geoportal/c/portal/logout?redirect=/atlas/";
				window.location = logoutUrl;
			}
		}
	};
</script>

<style scoped>

	.logout-content {
		background-color: white;
	}

</style>